import { sprintf } from 'sprintf-js';

import { Text } from 'components/Text/Text';
import { SearchLoadingSectionLine } from 'modules/search/components/Loading/SearchLoadingSectionLine';
import type { SearchType } from 'modules/search/types/SearchType';
import { LISTING_TYPE_HUMAN_NAME_MAP } from 'utils/constants/general/listingTypeHumanNameMap';
import { LISTING_TYPE_PLURAL_HUMAN_NAME_MAP } from 'utils/constants/general/listingTypePluralHumanNameMap';

type Props = {
  count: number | null;
  searchType: SearchType;
};

export function SearchResultsHeaderCount({ count, searchType }: Props) {
  if (count === null)
    return <SearchLoadingSectionLine width={64} height={20} />;

  const text =
    count === 1
      ? sprintf(getText('1 %(searchType)s'), {
          searchType: LISTING_TYPE_HUMAN_NAME_MAP[searchType],
        })
      : sprintf(getText('%(count)s %(searchType)s'), {
          count,
          searchType: LISTING_TYPE_PLURAL_HUMAN_NAME_MAP[searchType],
        });

  return (
    <Text
      tag="h2"
      styleAs="body"
      display={['block', 'block', 'block', 'inline-block']}
      fontSize="16px!important"
      mb={0}
      data-qa-id="result-count"
      data-result-count={count}
    >
      {text}
    </Text>
  );
}
